import { useAuth } from '@/context/AuthContext';

export default function DashboardPage() {
  const { user } = useAuth();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-lg font-semibold text-white">Dashboard</h1>
        <p className="text-zinc-500 text-xs mt-0.5">
          Selamat datang, {user?.email}
        </p>
      </div>

      <div className="bg-zinc-900 rounded-xl border border-zinc-800 p-6 max-w-md">
        <p className="text-zinc-400 text-sm">
          Boilerplate siap. Tambahkan fitur sesuai PRD.
        </p>
      </div>
    </div>
  );
}
